import { useState, useRef } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
export function Bio({
  bio
}: {
  bio?: string;
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  if (!bio) return null;
  return <div className="cursor-pointer select-none bg-primary/10  mt-2 rounded-lg text-foreground-heading" onClick={() => setIsExpanded(!isExpanded)} data-sentry-component="Bio" data-sentry-source-file="Bio.tsx">
      <div className="px-4 py-1.5">
        <div className="flex items-start justify-between gap-2">
          <div className={cn("text-sm  flex-1 overflow-hidden transition-all duration-300")} style={{
          height: isExpanded ? contentRef.current?.scrollHeight : Math.min(20, contentRef.current?.scrollHeight || 20)
        }}>
            <div ref={contentRef} style={isExpanded ? {} : {
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            overflow: "hidden"
          }}>
              {bio}
            </div>
          </div>
          <div className="flex-shrink-0 transition-transform duration-300" style={{
          transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)"
        }}>
            <ChevronDown className="h-4 w-4 mt-0.5" data-sentry-element="ChevronDown" data-sentry-source-file="Bio.tsx" />
          </div>
        </div>
      </div>
    </div>;
}